import React from 'react'

interface RowData {
    [key: string]: any
}

interface DataTableProps {
    items: RowData[]
}

const GenericTableforArrayofObjects: React.FC<DataTableProps> = ({ items }) => {
    const columns = Object.keys(items[0])

    return (
        <table className="admin-table" style={{ marginTop: '20px' }}>
            <thead>
                <tr className="admin-row-header admin-alt-row-data">
                    {columns.map((column, index) => (
                        <th key={index}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index} className="admin-alt-row-data">
                        {columns.map((column, columnIndex) => (
                            <td key={columnIndex}>
                                {React.isValidElement(item[column])
                                    ? item[column]
                                    : (typeof item[column] === 'object'
                                        ? JSON.stringify(item[column])
                                        : item[column]
                                    )
                                }
                            </td>))}
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default GenericTableforArrayofObjects
